import {
  routineComputerChoices,
  type RoutineComputerMachine,
} from './desktopTargetSelection';
import { useNativeInstanceId } from './nativeInstanceId';
import { useDesktopTargetRoster } from './useDesktopTargetRoster';

type RoutineComputerList =
  | { status: 'loading' }
  | { status: 'ready'; machines: RoutineComputerMachine[] };

/**
 * Choices for the routine "Preferred computer" dropdown, from the same roster as
 * the Run by picker. The roster only loads while the picker is shown, so hidden
 * pickers do not poll.
 */
export function useRoutineComputerChoices(pickerVisible: boolean): {
  computers: RoutineComputerList;
  thisComputerId: string | null;
} {
  const roster = useDesktopTargetRoster(pickerVisible);
  const instance = useNativeInstanceId(pickerVisible);

  if (!roster.data) {
    return {
      computers: { status: 'loading' },
      thisComputerId: null,
    };
  }
  const { machines, thisComputerId } = routineComputerChoices(
    roster.data.targets,
    instance.data ?? null
  );
  return {
    computers: { status: 'ready', machines },
    thisComputerId,
  };
}
